import { hex_md5 } from 'utils/md5';
import { SystemWxAppIdMap } from 'utils/constants';

let baseConfig = {
  appName: 'H5端',
  isLogin: false,
  isB2BLogin: false,
  isMultiOrg: true,
  sysType: 'entCenter',
  isMsgNotify: true,
  // homePath: '/',
  ENV: ENV,
  appKey: '',
  // 本地存储key
  localStorageKeys: {
    member_token: 'member_token', // 登录返回token
    member_userInfo: 'member_userInfo', // 登录返回用户信息
    member_recentSixNum: 'member_recentSixNum', // 记住最近登录的六个会员卡号
    member_cardSecret: 'member_cardSecret', // 实体会员卡号和密码
    member_realName: 'member_realName', // 会员姓名
    member_cardTypeData: 'member_cardTypeData', // 会员卡类型数据
    menber_helpUserId: 'menber_helpUserId', // 代客开卡 客的ID
    // 提交取到
    submitChannel: 'submitChannel',
    shop_cardTypeData: 'shop_cardTypeData', // 店铺卡类型数据
    login_lastPhoneNum: 'store_lastPhoneNum', // 上一个登录的手机账号
    member_appList: 'member_appList', // 首页-我的应用
    product_searchHistory: 'product_searchHistory', // 商品搜索
    shop_homeRecommend: 'shop_homeRecommend', // 首页“推荐数据”
    shop_homeBanner: 'shop_homeBanner', // 首页“推荐数据”
    shop_homeApplication: 'shop_homeApplication', // 首页“推荐数据”
    shop_homeNews: 'shop_homeNews', // 首页“推荐数据”
    shop_isShopCart: 'shop_isShopCart', // 核对订单页是否从购物车进来
    shop_confirmItems: 'shop_confirmItems', // 核对订单商品列表
    shop_giftItems: 'shop_giftItems', // 核对订单赠品列表
    shop_orderType: 'shop_orderType', // 订单类型
    shop_orderProperty: 'shop_orderProperty', // 配送比例
    shop_orderDiscount: 'shop_orderDiscount', // 折扣
    shop_checkOrderParams: 'shop_checkOrderParams', // 核对订单页面一些额外的参数
    shop_paymentData: 'shop_paymentData', // 支付页面缓存数据
    shop_paymentPayNo: 'shop_paymentPayNo', // 支付页面缓存支付号
    shop_paySuccData: 'shop_paySuccData', // 支付成功页面缓存数据
    shop_bizGiveawayReqDto: 'shop_bizGiveawayReqDto', // 赠品数据
    shop_couponAutoSelect: 'shop_couponAutoSelect', // 自动选择优惠券
    shop_rechargeData: 'shop_rechargeData', // 充值页面缓存数据
    member_applyCardMsg: 'member_applyCardMsg', // 申请开卡，记住用户填写的表单信息
    member_agentApplyCardMsg: 'member_agentApplyCardMsg', // 会员新客注册，记住客户的表单信息
    member_storeAgentApplyCardMsg: 'member_storeAgentApplyCardMsg', // 店铺新客注册，记住客户的表单信息
    virtual_applyCardMsg: 'virtual_applyCardMsg', // 虚拟资格新客注册，记住客户的表单信息
    virtual_applyCardOrderParams: 'virtual_applyCardOrderParams', // 虚拟资格新客注册，提交订单信息
    member_applyStoreMsg: 'member_applyStoreMsg', // 申请开店的店铺信息
    store_agentUpgradeMember: 'store_agentUpgradeMember', // 店铺老客升级的会员信息
    shop_wxOpenId: 'shop_wxOpenId',
    shop_paySuccDiscountAmount: 'shop_paySuccDiscountAmount', // 支付成功页优惠金额
    last_audio_detail: 'last_audio_detail', //每日优听最后一次播放的歌曲和时间
    loginGoback: 'loginGoback', //登录后是否返回到上一页
    loginGoback2: 'loginGoback2', //登录后是否返回到上上一页
    registerRoute: 'registerRoute', //注册后要回到的路由
    wechatTipBackHome: 'wechatTipBackHome', //引导页面点击返回按钮是否回到首页
    share_card_code: 'share_card_code', //分享的卡号
    yy_pay_wxOpenId: 'yy_pay_wxOpenId', // 甬易支付appid
    wx_pay_wxOpenId: 'wx_pay_wxOpenId', // 微信支付appid
    tl_pay_wxOpenid: 'tl_pay_wxOpenId', // 通联支付appid
    share_id: 'share_id',
    hj_pay_wxOpenId: 'hj_pay_wxOpenId', // 汇聚支付appid
    hlb_pay_wxOpenId: 'hlb_pay_wxOpenId', // 合利宝支付appid
    hf_pay_wxOpenId: 'hf_pay_wxOpenId', // 汇付天下支付appid
    ll_pay_wxOpenId: 'll_pay_wxOpenId', // 汇付天下支付appid
    qk_pay_wxOpenId: 'qk_pay_wxOpenId', // 快钱支付appid
    fu_pay_wxOpenId: 'fu_pay_wxOpenId', // 富友2支付appid
    course_buy: 'course_buy', // 是否是商学院购买
    last_open_card_Apply_info: 'last_open_card_Apply_info', //最后一次开卡的基本信息
    systemAgreementBack: 'systemAgreementBack', //站点合同是否返回到上一页
    bussiness_card: 'bussiness_card', // 名片手机号姓名缓存
    share_link_Id: 'share_link_Id', // 全局通过分享shareId存储
    renew_gift_order_flag: 'renew_gift_order_flag', // 是否续约礼订单
    th_cloud_warehouse: 'th_cloud_warehouse', //腾晖云仓下单
    th_cloud_register_submit_params: 'th_cloud_register_submit_params', //腾晖云仓代客下单调submit的入参
    th_cloud_upgrade_submit_params: 'th_cloud_upgrade_submit_params', //腾晖云仓代客升级调submit的入参
    gift_warehouse_address_info: 'gift_warehouse_address_info', // 礼品仓下单地址信息
    gift_warehouse_product_list: 'gift_warehouse_product_list', // 礼品仓下单商品信息
    modifySaleTag: 'modifySaleTag', // 申请开卡是否销售顾问修改过
    xbl_cloud_warehouse: 'xbl_cloud_warehouse', // 赋百龄云仓下单
    xbl_cloud_register_submit_params: 'xbl_cloud_register_submit_params', //赋百龄云仓代客下单调submit的入参
    xbl_cloud_upgrade_submit_params: 'xbl_cloud_upgrade_submit_params', //赋百龄云仓代客升级调submit的入参
    member_modal_message_isclick: 'member_modal_message_isclick' // 用户弹窗消息是否点击过
  },
  CDN_BASE: CDN_BASE,
  // 上传组件的默认显示图片
  uploadImgdefault: `${CDN_BASE}/assets/imgs/upload_default.png`,
  // 默认占位图
  defaultImg: `${CDN_BASE}/assets/imgs/default/default2.png`,
  mapKey: '', // 高德地图key
  custom: {
    thirdPartyCloud: 'obs'
  },
  xssSetting: {
    whiteList: {},
    // stripIgnoreTagBody: ["script"],
    onIgnoreTag(tag, html, options) {
      if (tag != 'script') {
        // 不对其属性列表进行过滤
        return html;
      }
    }
  }
};

function getQueryString(name = '') {
  const after = window.location.hash.split('?')[1] || '';
  if (after && name) {
    const reg = new RegExp(`(^|&)${name.trim()}=([^&]*)(&|$)`);
    const r = after.trim().match(reg);
    if (r != null) {
      return decodeURIComponent(r[2]);
    }
    return null;
  }
}

const systemCode = getQueryString('systemCode') || sessionStorage.getItem('systemCode');

const agentId = getQueryString('agentId') || sessionStorage.getItem('agentId');

if (systemCode === 'JCH') {
  envConfig.wxAppId = SystemWxAppIdMap[systemCode];
}

// 合并配置
const config = Object.assign(baseConfig, envConfig);

// js获取项目根地址，如： http://localhost:8083
const getRootPath = () => {
  let curPath = window.document.location.href;
  let pathName = window.document.location.pathname;
  let pos = curPath.indexOf(pathName);
  // 获取主机地址，如： http://localhost:8083
  let locPath = curPath.substring(0, pos);
  return locPath;
};

/**
 * 蜂鸟返回加密后的param
 * @param option
 */
export function signParam(param = {}) {
  const defaultParam = {
    appid: 'zt_001',
    deviceInfo: 'h5',
    times: parseInt(new Date() / 1000),
    version: '1.0',
    appkey: 'middle_pc',
    format: 'json'
  };
  const signParam = { ...defaultParam, ...param };

  let { params, signStr } = sortByAscii(signParam);
  const FENGNIAO_APP_SECRET = 'D5F1EWR1E21REWDF5WE5RDSFWR1WE';
  signStr += FENGNIAO_APP_SECRET;

  const sign = hex_md5(encodeURIComponent(signStr)).toLowerCase();

  return { ...params, sign };
}

/**
 * key value排序平成字符串
 *
 */
function sortByAscii(obj = {}) {
  const objKey = Object.keys(obj);
  const sortArr = objKey.sort();
  const sortObj = {};
  let signStr = '';
  sortArr.forEach((item, index) => {
    sortObj[item] = obj[item];
    signStr += item;
    signStr += obj[item];
  });
  return { params: sortObj, signStr: signStr };
}

/**
 * url请求数据组装
 * @param url
 * @param params
 * @returns {string | *}
 */
export function urlWithParams(url, params = {}) {
  const urlParams = [];
  for (const key in params) {
    let _paramStr = '';
    if (typeof params[key] === 'object') {
      _paramStr = `${key}=${JSON.stringify(params[key])}`;
    } else {
      _paramStr = `${key}=${params[key]}`;
    }
    urlParams.push(_paramStr);
  }

  if (url.indexOf('?') >= 0) {
    url = `${url}&${urlParams.join('&')}`;
  } else {
    url = `${url}?${urlParams.join('&')}`;
  }
  url = encodeURI(url);
  return url;
}

/**
 * 获得api接口地址
 * @param  {String} url    接口地址
 * @param  {Object} host   接口所在域
 * @param  {Object} app    接口所在工程的名称
 * @param  {Object} isMock 是否是mock接口
 * @return {String}        转换过的接口地址
 */
const getApiAppName = function ({
  url,
  host = '',
  isMock = false,
  version = 'v1',
  isFengNiao = false,
  fengNiaoParam = {}
}) {
  if (!url) {
    return;
  }
  if (url.indexOf('http') >= 0) {
    return url;
  }

  // 本机开发环境，则当前assets/mock下面的json
  if (config.mock || isMock) {
    return `${getRootPath() + config.publicPath}/assets/mock/${url.replace(/\//g, '-')}.json`;
    // 其它环境，则读取真实应用的接口
  }

  const _version = version || 'v1';
  const requestHost = host || config.HOST_MALL;
  let res = `${requestHost}/${_version}/${url}`;

  if (isFengNiao) {
    const params = signParam(fengNiaoParam);
    res = urlWithParams(`${requestHost}/${url}`, params || {});
  }
  return res;
};

// 拼接接口所需域名和服务名，只需要输入接口名即可  如 yundt/mgmt/item/list-by-page，也不要加斜杆开始，
// 如果接口以http开头，则不会进拼接，而是保留原样
// 如果是mock，则会去assets/mock请求同名json，但/会被替换为-   如  yundt-mgmt-item-list-by-page.js
config.apiAppName = getApiAppName;

export default config;



// WEBPACK FOOTER //
// ./src/config/Config.js